import auth0 from "auth0-js";
import config from "../Config";
import vdns_api from '../services/vdns_api';

export async function checkAuth () {
  const auth = new Auth();
  if (/access_token|id_token|error/.test(window.location.hash)) {
    const token = await auth.handleAuthentication();
    const permissions = await getPermissions(token);
    return Promise.resolve({
      token,
      permissions
    });
  } else if (!auth.isAuthenticated()) {
    return Promise.reject("unauthed");
  }
  const token = localStorage.getItem("id_token");
  const permissions = await getPermissions(token);
  return Promise.resolve({
    permissions,
    token
  });
}

async function getPermissions (token) {
  return {
    vdns: await vdns_api.isPermitted(token)
  };
}

export function login () {
  const auth = new Auth();
  auth.login();
}

export function logout () {
  const auth = new Auth();
  auth.logout();
  document.location.reload();
}

class Auth {
  auth0 = new auth0.WebAuth({
    "domain": config.AUTH0_DOMAIN,
    "clientID": config.AUTH0_CLIENT_ID,
    "redirectUri": config.AUTH0_REDIRECT_URI,
    "responseType": config.AUTH0_RESPONSE_TYPE,
    "scope": config.AUTH0_SCOPE
  });

  login = () => {
    this.auth0.authorize();
  };


  logout = () => {
    // Clear Access Token and ID Token from local storage
    localStorage.removeItem("access_token");
    localStorage.removeItem("id_token");
    localStorage.removeItem("expires_at");
  };

  isAuthenticated = () => {
    /*
     * Check whether the current time is past the
     * Access Token's expiry time
     */
    const expiresAt = JSON.parse(localStorage.getItem("expires_at"));
    return new Date().getTime() < expiresAt;
  };

  handleAuthentication = () => new Promise((resolve, reject) => {
    this.auth0.parseHash((err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        this.setSession(authResult);
        window.location.hash = "";
        resolve(authResult.idToken);
      } else if (err) {
        reject();
      }
    });
  });

  setSession (authResult) {
    // Set the time that the Access Token will expire at
    const expiresAt = JSON.stringify(authResult.expiresIn * 1000 + new Date().getTime());
    localStorage.setItem("access_token", authResult.accessToken);
    localStorage.setItem("id_token", authResult.idToken);
    localStorage.setItem("expires_at", expiresAt);
  }
}
